import React from "react";
import { ExportButton } from "@/components/ExportButton";
import {
  BooleanField,
  CreateButton,
  Datagrid,
  List,
  Pagination,
  TextField,
  TextInput,
  TopToolbar,
  type ListProps,
} from "react-admin";

const filters = [
  <TextInput
    key="q"
    source="q"
    label="Search name, phone, or remarks"
    alwaysOn
    sx={{ minWidth: 280 }}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export default function FmbThaliDistributorList(props: ListProps) {
  return (
    <List
      {...props}
      title="Thali Distributors"
      perPage={50}
      sort={{ field: "name", order: "ASC" }}
      filters={filters}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
      actions={<ListActions />}
    >
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="name" />
        <TextField source="phone" />
        <BooleanField source="portalEnabled" label="Portal" />
        <BooleanField source="isActive" />
        <TextField source="remarks" />
      </Datagrid>
    </List>
  );
}
